import { render } from "./BuildIcon.vue?vue&type=template&id=334cbf86&scoped=true"
import script from "./BuildIcon.vue?vue&type=script&lang=js"
export * from "./BuildIcon.vue?vue&type=script&lang=js"

import "./BuildIcon.vue?vue&type=style&index=0&id=334cbf86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334cbf86"]])

export default __exports__